import { emitSessionExpired } from './sessionExpired';

function requestHadAuthorizationHeader(input, init) {
  if (typeof Request !== 'undefined' && input instanceof Request) {
    return input.headers.has('Authorization');
  }
  if (!init || !init.headers) return false;
  const h = init.headers;
  if (typeof Headers !== 'undefined' && h instanceof Headers) {
    return h.has('Authorization');
  }
  if (Array.isArray(h)) {
    return h.some(([key]) => String(key).toLowerCase() === 'authorization');
  }
  return Object.keys(h).some((key) => key.toLowerCase() === 'authorization');
}

export function installAuthFetchInterceptor() {
  if (typeof window === 'undefined' || window.__authFetchInterceptorInstalled) {
    return;
  }
  window.__authFetchInterceptorInstalled = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const hadAuth = requestHadAuthorizationHeader(input, init);
    const response = await nativeFetch(input, init);
    if (response.status === 401 && hadAuth) {
      emitSessionExpired();
    }
    return response;
  };
}
